import { styled } from '@mui/material';
import { ReactComponent as IconMonitor } from '../../../assets/images/monitor.svg';

export const StyledIconMonitor = styled(IconMonitor)(() => ({
  cursor: 'pointer',
  height: '20px',
  width: '20px',
  fill: 'currentColor',
}));
